<template>
  <div>
    <form class="p-0">
      <div class="row justify-content-center">
        <!-- v-for para renderizar las tarjetas según el arreglo 'docs' -->
        <div
          v-for="(item, index) in docs"
          :key="index"
          class="col-12 col-md-4 col-xl-3 d-flex justify-content-center mb-4"
        >
          <div
            class="card border shadow-lg p-2 justify-content-around w-100 mb-1 mt-1 pl-0 pr-0"
            style="border-width: 2.5px !important; max-width: 350px"
            :class="{
              'border-success': item.exists,
              'border-danger': !item.exists
            }"
          >
            <div class="rounded-top">
              <file-pond
                name="test"
                :ref="'filePond' + index"
                label-idle="Agrega el documento aquí"
                accepted-file-types="image/jpeg, image/png, application/pdf"
                @updatefiles="updateFiles(index, $event)"
              />
            </div>
            <div class="rounded-bottom px-3">
              <div class="rounded-top">
                <!-- Este es el contenido de la tarjeta adicional -->
                <span class="mt-1 mb-2"><b>Título del documento:</b></span>

                <input
                  type="text"
                  class="form-control form-control-sm mt-1 mb-2"
                  placeholder="Título del documento"
                  v-model="item.type"
                />
              </div>
              <p class="mb-1">
                <span
                  ><b>Creado: </b
                  >{{
                    item.created_at.split(' ')[0].split('-').reverse().join('-')
                  }}</span
                >
              </p>
              <p class="mb-1">
                <span
                  ><b>Modificado: </b
                  >{{
                    item.updated_at.split(' ')[0].split('-').reverse().join('-')
                  }}</span
                >
              </p>
              <div
                class="w-100 d-flex justify-content-between align-items-center"
              >
                <i class="h3 bi-file-earmark-check text-success"></i>
                <div v-if="item.url_image && item.url_image !== ''">
                  <button
                    @click.prevent="viewFile(item.url_image)"
                    class="btn btn-primary btn-fill pt-1 pb-1 mr-2"
                  >
                    <i class="h4 bi-eye"></i>
                  </button>
                  <button
                    @click.prevent="deleteDocument(index)"
                    class="btn btn-danger btn-fill pt-1 pb-1"
                  >
                    <i class="h4 bi-trash-fill"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Div adicional que se verá como una tarjeta más -->
        <div
          class="col-12 col-md-4 col-xl-3 d-flex justify-content-center mb-4"
        >
          <div
            class="card border shadow-lg p-2 justify-content-around w-100 mb-1 mt-1 pl-0 pr-0"
            style="
              border-style: dashed !important;
              border-width: 4px !important;
              max-width: 350px;
            "
          >
            <div class="rounded-top">
              <file-pond
                name="test"
                ref="filePondNew"
                label-idle="<i class='bi bi-cloud-upload'></i> Agrega un nuevo documento"
                accepted-file-types="image/jpeg, image/png, application/pdf"
              />
            </div>
            <div class="rounded-top p-3">
              <label class="mt-1 mb-2">Título del nuevo documento</label>

              <input
                type="text"
                class="form-control form-control-sm mt-1 mb-2"
                placeholder="Título del documento"
                v-model="newDoc.title"
              />
            </div>
            <div class="rounded-bottom p-3 text-center">
              <button
                @click.prevent="saveNewDocument()"
                class="btn btn-primary w-100"
              >
                Guardar documento
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mb-2 d-flex justify-content-center">
        <button
          v-if="docs.length > 0"
          type="button"
          @click.prevent="saveDocuments()"
          class="btn btn-primary mt-2 w-50 btn-fill"
        >
          Actualizar documentos
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Swal from 'sweetalert2'
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
)

export default {
  components: {
    FilePond
  },
  data() {
    return {
      showImageModal: false,
      title: '',
      docs: [],
      newDoc: {
        title: '',
        url_image: []
      }
    }
  },
  created() {
    this.loadDocuments()
  },
  methods: {
    ...mapActions([
      'getData',
      'updateData',
      'createData',
      'changeStatusData',
      'optimizeImage'
    ]),

    async loadDocuments() {
      try {
        const response = await this.getData({ url: 'contract_template/all' })
        if (response.code === 200 && response.data) {
          this.docs = response.data.map((item) => ({
            id: item.id,
            type: item.title,
            file: '',
            url_image: item.url_image,
            created_at: item.created_at,
            updated_at: item.updated_at,
            exists: true
          }))
        }
      } catch (error) {
        console.error('Error al cargar documentos:', error)
      }
    },

    updateFiles(index, fileItems) {
      this.docs[index].file = fileItems.length ? fileItems[0].file : ''
    },

    viewFile(url) {
      window.open(url, '_blank')
    },
    async saveNewDocument() {
      const filePondNewInstance = this.$refs.filePondNew.getFiles()

      if (filePondNewInstance.length < 1) {
        Swal.fire({
          title: '¡Atención!',
          text: 'No hay ningun nuevo documento cargado',
          icon: 'warning',

          confirmButtonText: 'Aceptar'
        })
        return
      }
      if (this.newDoc.title == '') {
        Swal.fire({
          title: '¡Atención!',
          text: 'indique un título para el nuevo documento',
          icon: 'warning',

          confirmButtonText: 'Aceptar'
        })
        return
      }
      const formData = new FormData()
      formData.append('title', this.newDoc.title)
      // formData.append('url_image', filePondNewInstance[0].file)
      const compressedImage = await this.optimizeImage(
        filePondNewInstance[0].file
      )
      formData.append('url_image', compressedImage)

      try {
        await this.createData({
          url: 'contract_template/save',
          data: formData
        }).then((response) => {
          if (response.code === 200) {
            Swal.fire({
              title: 'Documento nuevo, guardado exitosamente.',
              text: `Documento guardado: ${this.newDoc.title}`,
              icon: 'success',

              confirmButtonText: 'Aceptar'
            }).then(() => {
              this.newDoc.title = ''
              this.$refs.filePondNew.removeFiles()
              this.clearFilePondRefs()
              this.loadDocuments()
            })
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    async saveDocuments() {
      Swal.fire({
        title: '¡Atención!',
        text: '¿Estás seguro de guardar los documentos?',
        icon: 'question',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, guardar'
      }).then((result) => {
        if (result.isConfirmed) {
          const uploadedDocs = []
          const failedDocs = []
          const promises = this.docs.map(async (element, index) => {
            const formData = new FormData()
            formData.append('title', element.type)
            formData.append('id_user', this.$route.params.id)

            const filePondInstance =
              this.$refs['filePond' + index][0].getFiles()
            if (filePondInstance.length > 0 && filePondInstance[0].file) {
              // formData.append('url_image', filePondInstance[0].file)
              // compressed Image
              const compressedImage = await this.optimizeImage(
                filePondInstance[0].file
              )
              formData.append('url_image', compressedImage)

              try {
                if (element.exists) {
                  const response = await this.updateData({
                    url: 'contract_template/update',
                    id: element.id,
                    data: formData
                  })
                  response.code === 200
                    ? uploadedDocs.push(element.type)
                    : failedDocs.push(element.type)
                } else {
                  const response = await this.createData({
                    url: 'contract_template/save',
                    data: formData
                  })
                  response.code === 200
                    ? uploadedDocs.push(element.type)
                    : failedDocs.push(element.type)
                }
              } catch {
                failedDocs.push(element.type)
              }
            } else {
              failedDocs.push(element.type)
            }
          })

          Promise.all(promises).then(() => {
            let title, message, icon

            if (failedDocs.length === 0) {
              title = 'Documentos guardados correctamente'
              message = `Documentos guardados: ${uploadedDocs.join(', ')}`
              icon = 'success'
            } else if (uploadedDocs.length === 0) {
              title = 'Advertencia'
              message = `Documentos que faltan por guardar: ${failedDocs.join(
                ', '
              )}`
              icon = 'warning'
            } else {
              title = 'Documentos actualizados correctamente'
              message = `Documentos actualizados: ${uploadedDocs.join(', ')}`
              icon = 'success'
            }

            Swal.fire({
              title: title,
              text: message,
              icon: icon,

              confirmButtonText: 'Aceptar'
            }).then(() => {
              this.clearFilePondRefs()
              this.loadDocuments()
            })
          })
        }
      })
    },

    async deleteDocument(index) {
      await Swal.fire({
        title: '¡Atención!',
        text: '¿Estás seguro de eliminar este documento?',
        icon: 'question',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, eliminar'
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await this.changeStatusData({
            url: 'contract_template/change_status',
            id: this.docs[index].id,
            status: 2
          })
          if (response.code === 200) {
            Swal.fire(
              'Eliminado',
              'Documento eliminado correctamente',
              'success'
            )
          } else {
            Swal.fire('Error', 'No se pudo eliminar el documento', 'error')
          }
          this.docs.splice(index, 1)
        }
      })
    },

    clearFilePondRefs() {
      this.docs.forEach((_, index) => {
        this.$refs['filePond' + index][0].removeFiles()
      })
    }
  }
}
</script>

<style>
.font-size-sm {
  font-size: 0.75rem !important;
}

.bg-info-document {
  background-color: #1fb7f30a !important;
}
.bg-success-document {
  background-color: #86cb1609 !important;
}
.bg-danger-document {
  background-color: #e460640c !important;
}
</style>
